'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = EventsWithFilters;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

var _containers = require('../containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EventsWithFilters(_ref) {
  var title = _ref.title;

  return _react2.default.createElement(
    'main',
    { className: 'EventsWithFilters' },
    title && _react2.default.createElement(
      'h2',
      null,
      title
    ),
    _react2.default.createElement(_containers.SearchBarContainer, null),
    _react2.default.createElement(_caligramReact.Button, { title: 'Filtrer par date, lieu, type d\u2019activit\xE9...', className: 'filtersLink', href: '#filters', width: 'full' }),
    _react2.default.createElement(
      'div',
      { className: 'events' },
      _react2.default.createElement(
        _containers.EventListContainer,
        null,
        function (props) {
          return _react2.default.createElement(_caligramReact.EventList, (0, _extends3.default)({ layout: 'grid', columns: 2, container: 8, groupBy: 'week' }, props));
        }
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'filters' },
      _react2.default.createElement(_containers.FiltersContainer, null)
    )
  );
}

EventsWithFilters.propTypes = {
  title: _react.PropTypes.string
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EventsWithFilters.js
// module id = 1141
// module chunks = 0